import petImageManifest from './petImageFilenames.generated.json';
import petIndustries from './petIndustries.generated.json';
import petWeights from './petWeights.generated.json';

const RAW_PET_PRODUCT_VARIANTS = [
  // LĂPTIC (CYLINDRICAL) — Volumes: 0.75L — Neck Finish: 38mm
  {
    id: 'pet-laptic-750',
    i18nKey: 'products.pet.products.laptic750',
    fillVolumeMl: 750,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'pharma'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },

  // KAROLACTA (CYLINDRICAL) — Volumes: 0.33L, 0.45L, 0.5L, 0.9L — Neck Finish: 38mm
  {
    id: 'pet-karolacta-330',
    i18nKey: 'products.pet.products.karolacta330',
    fillVolumeMl: 330,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },
  {
    id: 'pet-karolacta-450',
    i18nKey: 'products.pet.products.karolacta450',
    fillVolumeMl: 450,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },
  {
    id: 'pet-karolacta-500',
    i18nKey: 'products.pet.products.karolacta500',
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },
  {
    id: 'pet-karolacta-900',
    i18nKey: 'products.pet.products.karolacta900',
    fillVolumeMl: 900,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },

  // KAROLACTA (CYLINDRICAL) — Volumes: 1.5L — Neck Finish: 38/31
  {
    id: 'pet-karolacta-1500',
    i18nKey: null,
    fillVolumeMl: 1500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'cosmetics'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },

  // BABY (QUADRATIC) — Volumes: 0.25L, 0.35L, 0.4L, 0.5L, 1.0L — Neck Finish: 38mm
  {
    id: 'pet-baby-150',
    i18nKey: null,
    fillVolumeMl: 150,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'food', 'fresh'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-200',
    i18nKey: null,
    fillVolumeMl: 200,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-250',
    i18nKey: 'products.pet.products.baby250',
    fillVolumeMl: 250,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'food', 'fresh'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-350',
    i18nKey: 'products.pet.products.baby350',
    fillVolumeMl: 350,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'food', 'fresh'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-400',
    i18nKey: 'products.pet.products.baby400',
    fillVolumeMl: 400,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'food', 'fresh'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-500',
    i18nKey: 'products.pet.products.baby500',
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'food', 'fresh'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-1000',
    i18nKey: 'products.pet.products.baby1000',
    fillVolumeMl: 1000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'food', 'fresh'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-300',
    i18nKey: null,
    fillVolumeMl: 300,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-330',
    i18nKey: null,
    fillVolumeMl: 330,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },
  {
    id: 'pet-baby-450',
    i18nKey: null,
    fillVolumeMl: 450,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'square',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['square'],
  },

  // STANDARD (CYLINDRICAL) — Volumes: 1.0L — Neck Finish: PCO 1881
  {
    id: 'pet-standard-1000',
    i18nKey: 'products.pet.products.standard1000',
    fillVolumeMl: 1000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1881',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['oil', 'vinegar'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
    imageFilenames: ['Standard_1000ml_1.jpeg'],
  },

  // STANDARD ULEI (CYLINDRICAL) — Volumes: 1.0L — Neck Finish: 29/21
  {
    id: 'pet-standard-ulei-1000',
    i18nKey: null,
    fillVolumeMl: 1000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'oil2921',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['oil', 'vinegar'],
    neckTypes: ['oil2921'],
    shapes: ['round'],
    imageFilenames: ['Standard_Ulei_1000ml_1.jpeg'],
  },

  // STANDARD (CYLINDRICAL) — Volumes: 0.9L — Neck Finish: PCO 1881, 29/21
  {
    id: 'pet-standard-900',
    i18nKey: null,
    fillVolumeMl: 900,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1881',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['church'],
    neckTypes: ['pco1810', 'pco1881', 'oil2921'],
    shapes: ['round'],
  },

  // COMUNA (CYLINDRICAL) — Volumes: 0.5L — Neck Finish: PCO 1881
  {
    id: 'pet-comuna-500',
    i18nKey: 'products.pet.products.comuna500',
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['vinegar', 'syrups'],
    neckTypes: ['pco1810', 'pco1881', 'oil2921'],
    shapes: ['round'],
  },

  // COMUNA CU CRUCE (CYLINDRICAL) — Volumes: 0.5L — Neck Finish: PCO 1810, PCO 1881
  {
    id: 'pet-comuna-cu-cruce-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
    imageFilenames: ['Comuna-cu-cruce_500ml_1.jpeg'],
  },

  // CRIN (OVAL) — Volumes: 0.9L — Neck Finish: 38/31, PCO 1810
  {
    id: 'pet-crin-900',
    i18nKey: null,
    fillVolumeMl: 900,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'oval',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['chemicals', 'soap', 'detergent'],
    neckTypes: ['neck38mm', 'pco1810', 'pco1881'],
    shapes: ['oval'],
    imageFilenames: ['Crin_900ml_1.jpg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },

  // OȚET (CYLINDRICAL) — Volumes: 0.5L, 1.0L — Neck Finish: PCO 1881
  {
    id: 'pet-otet-500',
    i18nKey: 'products.pet.products.otet500',
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1881',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['vinegar', 'syrups'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
  },
  {
    id: 'pet-otet-1000',
    i18nKey: 'products.pet.products.otet1000',
    fillVolumeMl: 1000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1881',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['food', 'wine', 'chemicals', 'oil'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
  },

  // CRISTAL (CYLINDRICAL) — Volumes: 1.0L — Neck Finish: PCO 1881
  {
    id: 'pet-cristal-1000',
    i18nKey: 'products.pet.products.cristal1000',
    fillVolumeMl: 1000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['syrups', 'nonalcoholic', 'wine'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
  },

  // PERFECT (CYLINDRICAL) — Volumes: 2.0L — Neck Finish: PCO 1881
  {
    id: 'pet-perfect-2000',
    i18nKey: 'products.pet.products.perfect2000',
    fillVolumeMl: 2000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['wine', 'beer', 'dairy'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
  },

  // ROTUND (CYLINDRICAL) — Volumes: 0.5L, 1.0L — Neck Finish: PCO 1881
  {
    id: 'pet-rotund-500',
    i18nKey: 'products.pet.products.rotund500',
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'chemicals', 'soap'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
  },
  {
    id: 'pet-rotund-1000',
    i18nKey: 'products.pet.products.rotund1000',
    fillVolumeMl: 1000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'chemicals', 'soap'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['round'],
  },

  // ROTUND (CYLINDRICAL) — Volumes: 0.3L — Neck Finish: 38/31
  {
    id: 'pet-rotund-300',
    i18nKey: null,
    fillVolumeMl: 300,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic', 'icetea'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },

  // SĂPUN (CYLINDRICAL) — Volumes: 0.5L — Neck Finish: PCO 1881
  {
    id: 'pet-sapun-500',
    i18nKey: 'products.pet.products.sapun500',
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'rectangular',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['rectangular'],
  },

  // FINEȚE (CYLINDRICAL) — Volumes: 0.25L — Neck Finish: PCO 1881
  {
    id: 'pet-finete-250',
    i18nKey: 'products.pet.products.finete250',
    fillVolumeMl: 250,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'oval',
    availableColors: ['transparent', 'white', 'brown'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'chemicals', 'pharma'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['oval'],
  },

  // FINEȚE (OVAL) — Volumes: 0.5L — Neck Finish: PCO 1810
  {
    id: 'pet-finete-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'oval',
    availableColors: ['transparent', 'white', 'brown'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['oval'],
    imageFilenames: ['Finete_500ml_1.jpg'],
  },

  // ELEGANT (CYLINDRICAL) — Volumes: 0.5L — Neck Finish: PCO 1810, 38/31
  {
    id: 'pet-elegant-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent', 'white', 'brown'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['soap'],
    neckTypes: ['pco1810', 'pco1881', 'neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Elegant_500ml_1.jpeg'],
  },

  // ELEGANT LAPTE (CYLINDRICAL) — Volumes: 0.5L — Neck Finish: 38/31
  {
    id: 'pet-elegant-lapte-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Elegant_Lapte_500ml_1.jpeg'],
  },

  // FLACON (CYLINDRICAL) — Volumes: 0.2L — Neck Finish: PCO 1881, 30/25
  {
    id: 'pet-flacon-200',
    i18nKey: 'products.pet.products.flacon200',
    fillVolumeMl: 200,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent', 'brown'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'pharma'],
    neckTypes: ['pco1810', 'pco1881', 'neck3025'],
    shapes: ['round'],
  },

  // MINIFLACON (CYLINDRICAL) — Volumes: 0.15L — Neck Finish: PCO 1810, 30/25
  {
    id: 'pet-miniflacon-150',
    i18nKey: null,
    fillVolumeMl: 150,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'round',
    availableColors: ['transparent', 'brown'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy'],
    neckTypes: ['pco1810', 'pco1881', 'neck3025'],
    shapes: ['round'],
  },

  // MINIPICOLĂ (CYLINDRICAL) — Volumes: 0.05L — Neck Finish: 30/25
  {
    id: 'pet-minipicola-50',
    i18nKey: null,
    fillVolumeMl: 50,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck3025',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'pharma'],
    neckTypes: ['neck3025'],
    shapes: ['round'],
    imageFilenames: ['Minipicola_50ml_1.jpeg'],
  },

  // MINI (CYLINDRICAL) — Volumes: 0.05L, 0.1L — Neck Finish: 30/25
  {
    id: 'pet-mini-50',
    i18nKey: null,
    fillVolumeMl: 50,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck3025',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'pharma'],
    neckTypes: ['neck3025'],
    shapes: ['round'],
  },
  {
    id: 'pet-mini-100',
    i18nKey: null,
    fillVolumeMl: 100,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck3025',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'pharma'],
    neckTypes: ['neck3025'],
    shapes: ['round'],
  },

  // MINIPOCKET (RECTANGULAR) — Volumes: 0.15L — Neck Finish: PCO 1810
  {
    id: 'pet-minipocket-150',
    i18nKey: null,
    fillVolumeMl: 150,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'rectangular',
    availableColors: ['transparent', 'brown'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['chemicals'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['rectangular'],
  },

  // PICOLA (CYLINDRICAL) — Volumes: 0.1L — Neck Finish: 30/25
  {
    id: 'pet-picola-100',
    i18nKey: 'products.pet.products.picola100',
    fillVolumeMl: 100,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck3025',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['pharma', 'cosmetics', 'chemicals'],
    neckTypes: ['neck3025'],
    shapes: ['round'],
  },

  // FRESH (CYLINDRICAL) — Volumes: 0.25L — Neck Finish: 38/31
  {
    id: 'pet-fresh-250',
    i18nKey: 'products.pet.products.smoothies250',
    fillVolumeMl: 250,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['fresh', 'nonalcoholic', 'icetea', 'dairy'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },

  // OMNIA (CYLINDRICAL) — Volumes: 0.7L — Neck Finish: 38/31
  {
    id: 'pet-omnia-700',
    i18nKey: null,
    fillVolumeMl: 700,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['chemicals', 'alcoholic', 'sportsdrink'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },

  // VIO (CYLINDRICAL) — Volumes: 1.0L — Neck Finish: 38/31
  {
    id: 'pet-vio-1000',
    i18nKey: null,
    fillVolumeMl: 1000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'fresh', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Vio_1000ml_1.jpeg'],
  },

  // TINERET (CYLINDRICAL) — Volumes: 0.5L — Neck Finish: PCO 1881, 29/21
  {
    id: 'pet-tineret-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1881',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['oil', 'vinegar', 'wine', 'icetea', 'chemicals'],
    neckTypes: ['pco1810', 'pco1881', 'oil2921'],
    shapes: ['round'],
    imageFilenames: ['Tineret_500ml_1.jpeg'],
  },

  // BALSAM NR 1 (RECTANGULAR) — Volumes: 1.5L — Neck Finish: 38/31
  {
    id: 'pet-balsam-nr-1-1500',
    i18nKey: null,
    fillVolumeMl: 1500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'rectangular',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['detergent'],
    neckTypes: ['neck38mm'],
    shapes: ['rectangular'],
  },

  // BALSAM NR 2 (RECTANGULAR) — Volumes: 1.5L — Neck Finish: 38/31
  {
    id: 'pet-balsam-nr-2-1500',
    i18nKey: null,
    fillVolumeMl: 1500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'rectangular',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['detergent'],
    neckTypes: ['neck38mm'],
    shapes: ['rectangular'],
  },

  // LAPTE (CYLINDRICAL) — Volumes: 0.4L, 0.5L, 2.0L — Neck Finish: 38/31
  {
    id: 'pet-lapte-400',
    i18nKey: null,
    fillVolumeMl: 400,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['oil', 'vinegar', 'sportsdrink'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },
  {
    id: 'pet-lapte-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: [],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },
  {
    id: 'pet-lapte-2000',
    i18nKey: null,
    fillVolumeMl: 2000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['cosmetics', 'soap'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },

  {
    id: 'pet-lapte-patrat-2000',
    i18nKey: null,
    fillVolumeMl: 2000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Lapte_Patrat_2000ml_1.jpg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },

  // LAPTIC (CYLINDRICAL) — Volumes: 0.45L, 0.5L — Neck Finish: 38/31
  {
    id: 'pet-laptic-400',
    i18nKey: null,
    fillVolumeMl: 400,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: [],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
  },
  {
    id: 'pet-laptic-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Laptic_500ml_1.jpg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },

  // PRACTIC (RECTANGULAR) — Volumes: 0.5L — Neck Finish: PCO 1810
  {
    id: 'pet-practic-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'rectangular',
    availableColors: ['transparent', 'white', 'brown'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['chemicals', 'soap', 'detergent'],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['rectangular'],
    imageFilenames: ['Practic_500ml_1.jpeg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },

  // PACO (CYLINDRICAL) — Volumes: 0.9L — Neck Finish: 38/31
  {
    id: 'pet-paco-900',
    i18nKey: null,
    fillVolumeMl: 900,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'sportsdrink', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Paco_900ml_1.jpg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },

  // BASILICA (CYLINDRICAL) — Volumes: 0.85L, 0.95L — Neck Finish: 38/31
  {
    id: 'pet-basilica-850',
    i18nKey: null,
    fillVolumeMl: 850,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'nonalcoholic', 'oil'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Basilica_850ml_1.jpg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },
  {
    id: 'pet-basilica-950',
    i18nKey: null,
    fillVolumeMl: 950,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'nonalcoholic', 'oil'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Basilica_950ml_1.jpeg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },

  // SELECT (CYLINDRICAL) — Volumes: 0.4L, 0.5L — Neck Finish: 38/31
  {
    id: 'pet-select-400',
    i18nKey: null,
    fillVolumeMl: 400,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'sportsdrink', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Select_400ml_1.jpg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },
  {
    id: 'pet-select-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'round',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['dairy', 'sportsdrink', 'nonalcoholic'],
    neckTypes: ['neck38mm'],
    shapes: ['round'],
    imageFilenames: ['Select_500ml_1.jpg'],
    forceCatalogVisibility: true,
    hasTechSheet: false,
  },

  // LEBĂDĂ (RECTANGULAR) — Volumes: 0.5L, 0.75L — Neck Finish: PCO 1810
  {
    id: 'pet-lebada-500',
    i18nKey: null,
    fillVolumeMl: 500,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'rectangular',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: [],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['rectangular'],
  },
  {
    id: 'pet-lebada-750',
    i18nKey: null,
    fillVolumeMl: 750,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'pco1810',
    shape: 'rectangular',
    availableColors: ['transparent', 'white'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: [],
    neckTypes: ['pco1810', 'pco1881'],
    shapes: ['rectangular'],
  },

  // PLOȘCĂ (RECTANGULAR) — Volumes: 2.0L — Neck Finish: 38/31
  {
    id: 'pet-plosca-2000',
    i18nKey: null,
    fillVolumeMl: 2000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck38mm',
    shape: 'rectangular',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: [],
    neckTypes: ['neck38mm'],
    shapes: ['rectangular'],
  },

  // AVANTAJ (QUADRATIC) — Volumes: 3.0L — Neck Finish: 48mm
  {
    id: 'pet-avantaj-3000',
    i18nKey: 'products.pet.products.avantaj3000',
    fillVolumeMl: 3000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck48mm',
    shape: 'rectangular',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['detergent', 'chemicals'],
    neckTypes: ['neck48mm'],
    shapes: ['rectangular'],
  },

  // PREMIUM (QUADRATIC) — Volumes: 5.0L — Neck Finish: 48mm
  {
    id: 'pet-premium-5000',
    i18nKey: 'products.pet.products.premium5000',
    fillVolumeMl: 5000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck48mm',
    shape: 'square',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['chemicals', 'wine', 'water'],
    neckTypes: ['neck48mm'],
    shapes: ['square'],
  },

  // DAMIGEANA (CYLINDRICAL) — Volumes: 5.0L — Neck Finish: 48mm
  {
    id: 'pet-damigeana-5000',
    i18nKey: 'products.pet.products.damigeana5000',
    fillVolumeMl: 5000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck48mm',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['wine'],
    neckTypes: ['neck48mm'],
    shapes: ['round'],
  },

  // JUMBO (CYLINDRICAL) — Volumes: 10.0L — Neck Finish: 48mm
  {
    id: 'pet-jumbo-10000',
    i18nKey: 'products.pet.products.jumbo10000',
    fillVolumeMl: 10000,
    weightG: null,
    material: 'PET / rPET',
    pcrPossible: true,
    neckConnection: 'snapOn',
    neckType: 'neck48mm',
    shape: 'round',
    availableColors: ['transparent'],
    countryOfProduction: 'Romania',
    minimumOrderQuantity: 100000,
    segments: ['water', 'chemicals'],
    neckTypes: ['neck48mm'],
    shapes: ['round'],
  },
];

export const PET_PRODUCT_VARIANTS = RAW_PET_PRODUCT_VARIANTS.map((variant) => {
  const industries = Array.isArray(petIndustries?.[variant.id]) ? petIndustries[variant.id] : [];
  const weights = petWeights?.[variant.id] || null;
  const petWeightG = typeof weights?.petG === 'number' ? weights.petG : null;
  const glassWeightG = typeof weights?.glassG === 'number' ? weights.glassG : null;
  return {
    ...variant,
    industries,
    glassWeightG,
    petWeightG,
    weightG: typeof variant.weightG === 'number' ? variant.weightG : petWeightG,
  };
});

const PET_IMAGE_FILENAMES = Array.isArray(petImageManifest?.filenames) ? petImageManifest.filenames : [];

const HIDDEN_PET_VARIANT_IDS = new Set(['pet-mini-50', 'pet-mini-100']);

function toGroupKey(name) {
  return String(name)
    .trim()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
}

function toSentenceCaseName(name) {
  const s = String(name || '').trim();
  if (!s) return '';
  const lower = s.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

function normalizeParsedPetDisplayName(name) {
  return String(name || '').replace(/\bPatrtat\b/gi, 'Patrat');
}

function parsePetImageFilename(filename) {
  const file = String(filename);
  if (!/\.(jpe?g|png|webp|avif)$/i.test(file)) return null;

  const base = file.replace(/\.(jpe?g|png|webp|avif)$/i, '');

  // New convention (preferred): <name>_<ml>ml_<index>
  // Examples:
  //  - Lapte_2000ml_1
  //  - Balsam-Nr-1_1500ml_1   ("-" acts as space)
  {
    const parts = base.split('_');
    if (parts.length >= 3) {
      const indexToken = parts[parts.length - 1];
      const volumeToken = parts[parts.length - 2];
      const nameToken = parts.slice(0, -2).join('_');

      const idx = Number.parseInt(indexToken, 10);
      const volMatch = String(volumeToken).match(/(\d+(?:[.,]\d+)?)\s*ml$/i);

      if (Number.isFinite(idx) && idx > 0 && volMatch) {
        const ml = Number.parseInt(String(volMatch[1]).replace(/[.,]/g, ''), 10);
        if (Number.isFinite(ml) && ml > 0) {
          const displayName = toSentenceCaseName(
            normalizeParsedPetDisplayName(String(nameToken).replace(/[-_]+/g, ' ').trim())
          );
          return {
            name: displayName,
            groupKey: toGroupKey(displayName),
            ml,
            photoIndex: idx,
            filename: file,
          };
        }
      }
    }
  }

  // Back-compat: old convention with liters and optional (index)
  // Examples:
  //  - Laptic_0,5L
  //  - Karolacta_0,5
  //  - Laptic0,75L
  //  - Rotund_0.3L
  //  - Avantaj_3L
  const idxMatch = base.match(/\s*\((\d+)\)\s*$/);
  const photoIndex = idxMatch ? Number(idxMatch[1]) : 1;
  const core = idxMatch ? base.slice(0, idxMatch.index).trim() : base.trim();

  let m = core.match(/^(.+?)_(\d+(?:[.,]\d+)?)L?$/i);
  if (!m) m = core.match(/^([^\d]+?)(\d+(?:[.,]\d+)?)L?$/i);
  if (!m) return null;

  const name = String(m[1]).trim();
  const displayName = toSentenceCaseName(normalizeParsedPetDisplayName(name.replace(/[-_]+/g, ' ').trim()));
  const volRaw = String(m[2]).trim().replace(',', '.');
  const liters = Number.parseFloat(volRaw);
  if (!Number.isFinite(liters) || liters <= 0) return null;
  const ml = Math.round(liters * 1000);

  return {
    name: displayName,
    groupKey: toGroupKey(displayName),
    ml,
    photoIndex,
    filename: file,
  };
}

function toPublicPetImageUrl(filename) {
  const v = typeof petImageManifest?.generatedAt === 'string' ? petImageManifest.generatedAt : '';
  const suffix = v ? `?v=${encodeURIComponent(v)}` : '';
  return `${process.env.PUBLIC_URL}/images/pet/${encodeURIComponent(filename)}${suffix}`;
}

function buildImageCatalog(filenames) {
  /** @type {Map<string, {displayName: string|null, byMl: Map<number, Array<{filename: string, photoIndex: number}>>}>} */
  const map = new Map();

  for (const filename of filenames) {
    const parsed = parsePetImageFilename(filename);
    if (!parsed || !parsed.groupKey) continue;

    const entry = map.get(parsed.groupKey) || { displayName: parsed.name, byMl: new Map() };
    if (!entry.displayName) entry.displayName = parsed.name;

    const list = entry.byMl.get(parsed.ml) || [];
    list.push({ filename: parsed.filename, photoIndex: parsed.photoIndex });
    entry.byMl.set(parsed.ml, list);
    map.set(parsed.groupKey, entry);
  }

  for (const entry of map.values()) {
    for (const [ml, items] of entry.byMl.entries()) {
      const sorted = [...items].sort((a, b) => a.photoIndex - b.photoIndex || a.filename.localeCompare(b.filename));
      entry.byMl.set(ml, sorted);
    }
  }

  return map;
}

function formatLitersFromMl(ml) {
  const liters = ml / 1000;
  const s = Number.isInteger(liters) ? String(liters) : String(liters).replace(/0+$/g, '').replace(/\.$/, '');
  return `${s}L`;
}

function inferGroupKeyFromVariantId(id) {
  const match = String(id || '').match(/^pet-(.+)-(\d+)$/);
  return match ? match[1] : '';
}

function buildPetCatalogVariant(meta, fallbackImageFilenames = []) {
  const variant = {
    id: meta.id,
    i18nKey: meta?.i18nKey || null,
    fillVolumeMl: meta?.fillVolumeMl ?? null,
    weightG: meta?.weightG ?? null,
    petWeightG: meta?.petWeightG ?? null,
    glassWeightG: meta?.glassWeightG ?? null,
    material: meta?.material || 'PET / rPET',
    neckConnection: meta?.neckConnection || null,
    neckType: meta?.neckType || null,
    shape: meta?.shape || null,
    color: meta?.color || 'transparent',
    availableColors: Array.isArray(meta?.availableColors) ? meta.availableColors : [],
    countryOfProduction: meta?.countryOfProduction || null,
    minimumOrderQuantity: meta?.minimumOrderQuantity ?? null,
    segments: Array.isArray(meta?.segments) ? meta.segments : [],
    industries: Array.isArray(meta?.industries) ? meta.industries : [],
    neckTypes: Array.isArray(meta?.neckTypes) ? meta.neckTypes : [],
    shapes: Array.isArray(meta?.shapes) ? meta.shapes : [],
    images: [],
    hasTechSheet: meta?.hasTechSheet === true,
  };

  let filenames = Array.isArray(fallbackImageFilenames)
    ? fallbackImageFilenames.filter((filename) => typeof filename === 'string' && filename.trim())
    : [];

  const explicitImageFilenames = Array.isArray(meta?.imageFilenames)
    ? meta.imageFilenames.filter((filename) => typeof filename === 'string' && filename.trim())
    : [];

  if (explicitImageFilenames.length) {
    filenames = explicitImageFilenames;
  }

  if (variant.id === 'pet-elegant-500') {
    filenames = filenames.filter((f) => /^Elegant_\d+(?:[.,]\d+)?ml_\d+/i.test(String(f)));
  }

  if (variant.id === 'pet-elegant-lapte-500') {
    filenames = filenames.filter((f) => /^(Elegant|Elegent)_Lapte_\d+(?:[.,]\d+)?ml_\d+/i.test(String(f)));
  }

  variant.images = filenames.map(toPublicPetImageUrl);
  return variant;
}

function buildPetProductGroups(variants) {
  const imageCatalog = buildImageCatalog(PET_IMAGE_FILENAMES);

  const variantMetaById = new Map(variants.map((v) => [v.id, v]));

  /** @type {Map<string, {id: string, groupKey: string, displayName: string|null, variants: any[]}>} */
  const groups = new Map();

  // Build the catalog from images (only image-backed variants appear).
  for (const [groupKey, entry] of imageCatalog.entries()) {
    const groupId = `pet-${groupKey}`;
    const g = groups.get(groupId) || { id: groupId, groupKey, displayName: entry.displayName || null, variants: [] };
    if (!g.displayName && entry.displayName) g.displayName = entry.displayName;

    for (const [ml, items] of entry.byMl.entries()) {
      const id = `pet-${groupKey}-${ml}`;
      if (HIDDEN_PET_VARIANT_IDS.has(id)) continue;
      const meta = variantMetaById.get(id) || null;
      const variant = buildPetCatalogVariant(
        meta || {
          id,
          fillVolumeMl: ml,
        },
        items.map((x) => x.filename)
      );
      g.variants.push(variant);
    }

    groups.set(groupId, g);
  }

  for (const meta of variants) {
    if (!meta?.forceCatalogVisibility) continue;
    if (HIDDEN_PET_VARIANT_IDS.has(meta.id)) continue;

    const groupKey = inferGroupKeyFromVariantId(meta.id);
    if (!groupKey) continue;

    const groupId = `pet-${groupKey}`;
    const fallbackDisplayName = toSentenceCaseName(groupKey.replace(/-/g, ' '));
    const g = groups.get(groupId) || { id: groupId, groupKey, displayName: fallbackDisplayName, variants: [] };

    if (g.variants.some((variant) => variant.id === meta.id)) {
      groups.set(groupId, g);
      continue;
    }

    g.variants.push(buildPetCatalogVariant(meta));
    groups.set(groupId, g);
  }

  // Sort variants + compute volumesLabel
  const result = [...groups.values()].map((g) => {
    const variantsSorted = [...g.variants].sort((a, b) => a.fillVolumeMl - b.fillVolumeMl);
    const volumesLabel = variantsSorted.map((v) => formatLitersFromMl(v.fillVolumeMl)).join(' / ');
    return { ...g, variants: variantsSorted, volumesLabel };
  });

  // Stable-ish ordering
  result.sort((a, b) => a.groupKey.localeCompare(b.groupKey));

  return result;
}

export const PET_PRODUCTS = buildPetProductGroups(PET_PRODUCT_VARIANTS);

export function getPetProductVariantById(id) {
  for (const g of PET_PRODUCTS) {
    const v = g.variants.find((x) => x.id === id);
    if (v) return v;
  }
  return null;
}

export function getPetProductGroupById(id) {
  return PET_PRODUCTS.find((g) => g.id === id) || null;
}

export function getPetProductById(id) {
  const group = getPetProductGroupById(id);
  if (group) return group;

  for (const g of PET_PRODUCTS) {
    if (g.variants.some((v) => v.id === id)) return g;
  }
  return null;
}
